/* Copyright 2013 - 2024 Waiterio LLC */
/** @jsxImportSource @emotion/react */
import { useTranslation } from '@multilocale/react/index.jsx'

const SearchJumbotron = ({ language }) => {
  const { t } = useTranslation(language)

  return (
    <div
      css={{
        height: '80vh',
        background: '#5cb85c',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        css={{
          background: 'white',
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '60vw',
          marginTop: '10vh',
        }}
      >
        <h1 css={{ color: '#5cb85c', fontSize: 48, margin: '32px 0 0 0' }}>
          {t('Takeaway')}
        </h1>
        <div css={{ display: 'flex', margin: 32 }}>
          <input
            placeholder={t('Enter your address')}
            css={{ color: 'black', fontSize: 20, padding: 16, width: '30vw' }}
          />
          <button
            type="button"
            css={{
              color: 'white',
              background: '#5cb85c',
              fontSize: 20,
              padding: 16,
              textTransform: 'uppercase',
            }}
          >
            {t('Find restaurants')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SearchJumbotron
